module.exports = __webpack_public_path__ + "img/solutionBanner2.ee994bc9.png";